<div class="banner__content col-12 margin-10">
    <div class="row">
        <div class="banner__actions col-12 col-lg-4">
            <div [ngClass]="show0 ? 'banner__sub banner__sub--inactive d-flex align-items-start':'banner__sub banner__sub--active d-flex align-items-start'"
                (click)="toggle(0)">
                <img class="mr-2" src="assets/img/form.png" alt="">
                <h3 class="pt-1">Infracción</h3>
            </div>
            <div [ngClass]="show0 ? 'animation-container--closed' : 'animation-container'">
                <div class="banner__list  banner__list--show">
                    <div class="banner__action" routerLink="/infractions">
                        <h5>Ingresar una infracción</h5>
                        <p>Formulario para infracción a conductor.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/search/driver">
                        <h5>Buscar conductor</h5>
                        <p>Buscar por nombre, rut o correo.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/reports/infractions">
                        <h5>Informe de infracciones</h5>
                        <p>Infracciones por período y/o lugar.
                            <p>
                    </div>
                </div>
            </div>

        </div>
        <div class="banner__actions col-12 col-lg-4">
            <div [ngClass]="show1 ? 'banner__sub banner__sub--inactive d-flex align-items-start':'banner__sub banner__sub--active d-flex align-items-start'"
                (click)="toggle(1)">
                <img class="mr-2" src="assets/img/verificar.png" alt="">
                <h3 class="pt-1">Verificación</h3>
            </div>
            <div [ngClass]="show1 ? 'animation-container--closed' : 'animation-container'">
                <div class="banner__list  banner__list--show">
                    <div class="banner__action" routerLink="/verification/licenses">
                        <h5>Licencias</h5>
                        <p>Verificar estado de licencias.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/verification/requests" [state]="{ tabNumber:3}">
                        <h5>Solicitudes</h5>
                        <p>Revisión del estado de solicitudes.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/verification/infractions" [state]="{ tabNumber:2}">
                        <h5>Mis sanciones</h5>
                        <p>Revisión del historial de sanciones.
                            <p>
                    </div>
                </div>
            </div>

        </div>
        <div class="banner__actions col-12 col-lg-4">
            <div [ngClass]="show2 ? 'banner__sub banner__sub--inactive d-flex align-items-start':'banner__sub banner__sub--active d-flex align-items-start'"
                (click)="toggle(2)">
                <img class="mr-2" src="assets/img/id.png" alt="">
                <h3>Solicitar</h3>
            </div>

            <div [ngClass]="show2 ? 'animation-container--closed' : 'animation-container'">
                <div class="banner__list  banner__list--show">
                    <div class="banner__action" routerLink="/license/new">
                        <h5>Crear solicitud nueva licencia</h5>
                        <p>Formulario para empleados y contratistas.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/license/renew">
                        <h5>Renovar licencia</h5>
                        <p>Acceso para renovar documentos o contrato.
                            <p>
                    </div>
                    <div class="banner__action mt-2" routerLink="/license/extend">
                        <h5>Ampliar licencia</h5>
                        <p>Formulario para modificar equipos registrados.
                            <p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
